import React, { useEffect, useState } from 'react';
import { useNavigate } from "react-router-dom";
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import * as model from '../../../models/UserRolesModel';
import { apiError } from '../../../helpers/ErrorHelper';
import { useAuth } from '../../../context/AuthContext';
import { useNotificationCount } from '../../../context/NotificationCountContext';
import { MySelect, Text } from '../../inputs/inputs';
import { formatDataBeforeDisplay, formatDataBeforeSend } from '../../../helpers/GeneralHelper';

export const UserRoleForm = ({module, showModal, setShowModal, refreshData, data, modalKey}) => {

  const inputFields = {
    urole_title: '',
    urole_permission: '',
    urole_type: '',
    role_client_specific: 0,
  }
  const formatOptions = [];

  const { notificationCount, setNotificationCount } = useNotificationCount();

  const navigate = useNavigate(); 

  const { state } = useAuth();
  let user_data = state.user_data;
  
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  
  const [id, setId] = useState('');
  const [fields, setFields] = useState(inputFields);

  const closeModal = () =>{
    setId('');
    setFields(inputFields);
    setErrors({});

    setShowModal(false);
  }

  const modules = [
    { route: 'clients', title: 'Clients'},
    { route: 'contacts', title: 'POCs'},
    { route: 'requirements', title: 'Requirements'},
    { route: 'candidates', title: 'Candidates'},
    { route: 'interviews', title: 'Interviews'},
    { route: 'onboards', title: 'Onboards'},
    { route: 'users', title: 'Team Members'},
    { route: 'designations', title: 'Designations'},
    { route: 'skills', title: 'Skills'},
    { route: 'requirement-status', title: 'Requirement Status'},
    { route: 'mode-of-works', title: 'Mode of Works'},
    { route: 'candidate-status', title: 'Candidate Status'},
    { route: 'interview-rounds', title: 'Interview Rounds'},
    { route: 'interview-status', title: 'Interview Status'},
    { route: 'user-roles', title: 'User Roles'},
    { route: 'invoices', title: 'Invoices'},
    { route: 'offboards', title: 'Offboards'},
    { route: 'meetings', title: 'Meetings'},
    { route: 'leaving-reason', title: 'Leaving Reasons'},
    { route: 'reports', title: 'Reports'},
    { route: 'resumes', title: 'Resumes'},
  ];

  const actions = ['view', 'add', 'edit', 'delete', 'trash'];

  const optionsTypes = [
    {value: 'admin', label: 'Admin' },
    {value: 'manager', label: 'Manager' },
    // {value: 'client_manager', label: 'Client Manager' },
  ];
  const yesNoOptions = [
    { value: 0, label: 'No'},
    { value: 1, label: 'Yes'},
  ];

  useEffect(() => {
    // This effect will be called whenever data changes
    if (data) {
      setId(data[module.primaryCol]);

      try {
        data.urole_permission = data.urole_permission ? JSON.parse(data.urole_permission) : '';
      } catch (e) {
        
      }

      setFields(formatDataBeforeDisplay(data, formatOptions));
      setErrors({});
    }
  }, [data, modalKey]);
  
  const submit = async(e) => {
    e.preventDefault();
    
    // Start the loading state
    setLoading(true);

    try {
      // Clear previous errors
      setErrors({});

      const formData = formatDataBeforeSend(fields, inputFields, formatOptions);
      formData.set('urole_permission', JSON.stringify(fields.urole_permission));
      
      let response;
      if (data) {
        response = await model.update(user_data.user_token, id, formData);
      } else {
        response = await model.create(user_data.user_token, formData);
      }

      if (response.status) {
        setNotificationCount(localStorage.getItem('unread_notification_count'));
        toast.success(response.message);
        closeModal();

        model.saveToStorage(response.data[module.key], response.data.pagination);
        refreshData();
      } else {
        setErrors(response.error);
        toast.error(response.message);
      }
    } catch (error) {
      apiError(error);

      if (error.response?.data.invalid_token == 1) {
        navigate('/re-login');
      }
    }

    // Stop the loading state
    setLoading(false);
  }

  return (
    <Modal className="cms-modal-form" show={showModal} onHide={closeModal} size='xl' backdrop="static">
        <Modal.Header closeButton>
            <Modal.Title>{modalKey == null ? 'Add' : 'Edit'} {module.singularTitle}</Modal.Title>
        </Modal.Header>

        <form onSubmit={submit}>
          <Modal.Body>
            <div className="row gy-2">
              <div className="col-sm-4 mt-3">
                <Text column="urole_title" label="Role Name" required={true} fields={fields} setFields={setFields} errors={errors} ></Text>
              </div>
              
              <div className="col-sm-4 mt-3">
                <MySelect options={optionsTypes} firstOption={true} column="urole_type" label="Type" fields={fields} setFields={setFields} errors={errors} />
              </div>
              <div className="col-sm-4 mt-3">
              <MySelect options={yesNoOptions} firstOption={false} column="role_client_specific" label="Client Specific?" fields={fields} setFields={setFields} errors={errors} />
              </div>
              
              <div className="col-sm-12 mt-3">
                <table className='table table-bordered table-hover table-sm'>
                  <thead>
                    <tr>
                      <th>Module</th>
                      <th>View</th>
                      <th>Add</th>
                      <th>Edit</th>
                      <th>Delete</th>
                      <th>Trash</th>
                    </tr>
                  </thead>
                  <tbody>
                    {modules.map((item) => {
                      return <tr key={item.route}>
                        <td>{ item.title }</td>
                        {actions.map((action) => <td key={action}><input type="checkbox" checked={fields.urole_permission?.[item.route]?.[action] ?? false} 
                          onChange={(e) => 
                            setFields((prev) => (
                              {...prev, urole_permission: { ...prev.urole_permission, [item.route]: { ...prev.urole_permission[item.route], [action]: e.target.checked }}}
                            ))
                          }
                          /></td>)}
                      </tr>
                    })}
                  </tbody>
                </table>
              </div>
            </div>

          </Modal.Body>

          <Modal.Footer>
              <button type="button" className="btn btn-light" onClick={closeModal}>Cancel</button>
              <button className="btn btn-primary" disabled={loading}>
                {loading ? <span><span className="spinner-border spinner-border-sm align-middle"></span> Loading...</span> : 'Submit'}
              </button>
          </Modal.Footer>
        </form>
    </Modal>
  );
};
